import { title } from 'process';
import React, { useCallback } from 'react';
import './style.scoped.css';

export interface ScrollItem {
  id: string;
  iconActive: string;
  iconInactive: string;
  title: string;
  disabled?: boolean;
}

interface ScrollItemSelectorProps {
  data: ScrollItem[];
  selected: string;
  onSelect?: (string) => void;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

const ScrollItemSelector = ({
  data,
  selected,
  onSelect,
  scrollRef,
}: ScrollItemSelectorProps) => {
  const _handleClick = useCallback(
    (item: ScrollItem) => {
      if (item.disabled || item.id == selected) return;
      onSelect && onSelect(item.id);
    },
    [selected, onSelect]
  );

  const _renderItem = useCallback(
    (item: ScrollItem, index: number) => {
      let isActive: boolean = item.id == selected;
      return (
        <div
          onClick={() => _handleClick(item)}
          className={
            (isActive ? 'itemActive' : 'itemInactive') +
            (item.disabled ? ' opacity-30' : '') +
            (index < data.length - 1 ? ' mr-4' : '')
          }
          key={item.id}
        >
          <img
            src={isActive ? item.iconActive : item.iconInactive}
            className="w-9 h-9 "
          />
          <div className="h-5" />
          <div
            className={
              'text-center titleText ' +
              (isActive ? 'text-onPrimary' : 'text-primary')
            }
          >
            {item.title}
          </div>
        </div>
      );
    },
    [selected, _handleClick, data]
  );

  return <div className="scrollContainer" ref={scrollRef}>{data.map(_renderItem)}</div>;
};

export default ScrollItemSelector;
